import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchSiteReprocess } from "../thunk/SitesOverviewThunk";

const initialData: any = [];

const   SiteReprocessChartSlice: Slice<any, {}, "SiteReprocessChartSlice"> = createSlice({
    name: "SiteReprocessChartSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchSiteReprocess.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchSiteReprocess.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchSiteReprocess.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default SiteReprocessChartSlice
